import { EditableUserData } from '../../redux/types';

type UserData = Omit<EditableUserData, 'registrationdata'>;

export const setInitialUserDataForReactFinalForm = (user: UserData):
  Record<string, any> | undefined => {
  if (Object.keys(user).length === 0) {
    return undefined;
  }

  const initialData = {
    userGender: user.gender,
    userTitle: user.title,
    userFirstName: user.firstname,
    userLastName: user.surname,
    userCountry: user.userCountry,
    newsletterOptIn: user.newsletterOptIn,
    notificationOptOut: user.notificationOptOut,
  };

  return initialData;
};

export const parseToQuipUserData = (reactFinalFormUser: any): Record<string, any> => {
  const userData = {
    gender: reactFinalFormUser.userGender,
    title: reactFinalFormUser.userTitle || null,
    firstname: reactFinalFormUser.userFirstName,
    surname: reactFinalFormUser.userLastName,
    userCountry: reactFinalFormUser.userCountry,
    newsletterOptIn: reactFinalFormUser.newsletterOptIn,
    notificationOptOut: reactFinalFormUser.notificationOptOut,
  };

  return userData;
};
